var map = {
	"./aws.png": 6921,
	"./css.png": 6135,
	"./html.png": 5935,
	"./ionic.png": 1829,
	"./jquery.png": 2161,
	"./js.png": 74,
	"./laravel.png": 1350,
	"./mongo.png": 7218,
	"./ng.png": 1695,
	"./node.png": 1069,
	"./react.png": 2191,
	"./rn.png": 31,
	"./ts.png": 2030,
	"./xd.png": 9247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2316;